/**
 * Constantes de movimiento del MVP (TKT-012, TKT-013).
 *
 * Las posiciones se expresan en "unidades de mundo" abstractas (1 unidad = 1 tile
 * lógico en el plano isométrico). La conversión a píxeles vive en game-pc.
 */

/** Velocidad máxima en unidades/segundo. */
export const MAX_PLAYER_SPEED = 6.0;

/** Tick rate de la simulación autoritativa (ADR-0003). */
export const TICK_RATE_HZ = 30;

/** Tasa de broadcast del snapshot al PC (ADR-0003). */
export const SNAPSHOT_RATE_HZ = 20;

/** Tasa de muestreo de input del móvil (ADR-0003). */
export const INPUT_SAMPLE_RATE_HZ = 20;

/** Duración del tick en milisegundos (~33.33 ms a 30 Hz). */
export const TICK_DURATION_MS = 1000 / TICK_RATE_HZ;

/** Intervalo del snapshot en milisegundos (50 ms a 20 Hz). */
export const SNAPSHOT_INTERVAL_MS = 1000 / SNAPSHOT_RATE_HZ;

/** Buffer de interpolación cliente PC (TKT-015 default 100 ms). */
export const INTERPOLATION_BUFFER_MS_DEFAULT = 100;

/** Si no llega snapshot en este tiempo, el sprite se queda quieto (TKT-015). */
export const SNAPSHOT_STALL_TIMEOUT_MS = 250;

/** Umbral para considerar una divergencia como "reconciliation correction". */
export const RECONCILIATION_THRESHOLD_UNITS = 1.0;

/** Cap defensivo de inputs/s antes de cerrar la conexión (TKT-012). */
export const INPUT_RATE_HARD_LIMIT_HZ = 25;
